import { createReducer } from './utils.js';
import {
  GET_TENANT_USERS_REQUEST,
  GET_TENANT_USERS_SUCCESS,
  GET_TENANT_USERS_FAILURE,
  CREATE_TENANT_USER_REQUEST,
  CREATE_TENANT_USER_SUCCESS,
  CREATE_TENANT_USER_FAILURE,
  UPDATE_TENANT_USER_REQUEST,
  UPDATE_TENANT_USER_SUCCESS,
  UPDATE_TENANT_USER_FAILURE,
  DELETE_TENANT_USER_REQUEST,
  DELETE_TENANT_USER_SUCCESS,
  DELETE_TENANT_USER_FAILURE,
  SNACK_SET,
} from './constants.js';

const defaultState = {
  loading: false,
  errorMessage: null,
  tenantUsers: [],
};

export const reducer = createReducer(defaultState, {
  [GET_TENANT_USERS_REQUEST]: handleGetTenantUsersRequest,
  [GET_TENANT_USERS_SUCCESS]: handleGetTenantUsersSuccess,
  [GET_TENANT_USERS_FAILURE]: handleGetTenantUsersFailure,
  [CREATE_TENANT_USER_REQUEST]: handleCreateTenantUserRequest,
  [CREATE_TENANT_USER_SUCCESS]: handleCreateTenantUserSuccess,
  [CREATE_TENANT_USER_FAILURE]: handleCreateTenantUserFailure,
  [UPDATE_TENANT_USER_REQUEST]: handleUpdateTenantUserRequest,
  [UPDATE_TENANT_USER_SUCCESS]: handleUpdateTenantUserSuccess,
  [UPDATE_TENANT_USER_FAILURE]: handleUpdateTenantUserFailure,
  [DELETE_TENANT_USER_REQUEST]: handleDeleteTenantUserRequest,
  [DELETE_TENANT_USER_SUCCESS]: handleDeleteTenantUserSuccess,
  [DELETE_TENANT_USER_FAILURE]: handleDeleteTenantUserFailure,
});

function handleGetTenantUsersRequest(state) {
  return {
    ...state,
    loading: true,
    errorMessage: null,
  };
}

function handleGetTenantUsersSuccess(state, { payload: { users } }) {
  return {
    ...state,
    tenantUsers: users,
    loading: false,
    errorMessage: null,
  };
}

function handleGetTenantUsersFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    errorMessage: error.message || String(error),
  };
}

function handleCreateTenantUserRequest(state) {
  return {
    ...state,
    loading: true,
    errorMessage: null,
  };
}

function handleCreateTenantUserSuccess(state) {
  return {
    ...state,
    loading: false,
    errorMessage: null,
  };
}

function handleCreateTenantUserFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    errorMessage: error.message || String(error),
  };
}

function handleUpdateTenantUserRequest(state) {
  return {
    ...state,
    loading: true,
    errorMessage: null,
  };
}

function handleUpdateTenantUserSuccess(state) {
  return {
    ...state,
    loading: false,
    errorMessage: null,
  };
}

function handleUpdateTenantUserFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    errorMessage: error.message || String(error),
  };
}

function handleDeleteTenantUserRequest(state) {
  return {
    ...state,
    loading: true,
    errorMessage: null,
  };
}

function handleDeleteTenantUserSuccess(state) {
  return {
    ...state,
    loading: false,
    errorMessage: null,
  };
}

function handleDeleteTenantUserFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    errorMessage: error.message || String(error),
  };
}

export function getTenantUsers(tenant_id) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: GET_TENANT_USERS_REQUEST });
    try {
      const users = await dataSource.getTenantUsers(tenant_id);
      dispatch({ type: GET_TENANT_USERS_SUCCESS, payload: { users: users } });
    } catch (error) {
      dispatch({ type: GET_TENANT_USERS_FAILURE, payload: { error: { message: error.message || String(error) } } });
      const snack = {
        open: true,
        message: 'Error al obtener los usuarios del tenant: ' + (error.message || String(error)),
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function createTenantUser(userData) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: CREATE_TENANT_USER_REQUEST });
    try {
      await dataSource.createTenantUser(userData);
      dispatch({ type: CREATE_TENANT_USER_SUCCESS });
      const snack = {
        open: true,
        message: 'Usuario creado exitosamente',
        severity: 'success',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
      // Recargar la lista de usuarios
      dispatch(getTenantUsers(userData.tenant_id));
    } catch (error) {
      // No enviamos el error al state, solo mostramos el snack
      dispatch({ type: CREATE_TENANT_USER_SUCCESS }); // Marcamos como éxito para no alterar la UI
      const snack = {
        open: true,
        message: 'Error al crear usuario: ' + (error.message || String(error)),
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
      // Aseguramos que la lista de usuarios se mantenga actualizada
      dispatch(getTenantUsers(userData.tenant_id));
    }
  };
}

export function updateTenantUser(user_id, userData) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: UPDATE_TENANT_USER_REQUEST });
    try {
      await dataSource.updateTenantUser(user_id, userData);
      dispatch({ type: UPDATE_TENANT_USER_SUCCESS });
      const snack = {
        open: true,
        message: 'Usuario actualizado exitosamente',
        severity: 'success',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
      // Recargar la lista de usuarios
      dispatch(getTenantUsers(userData.tenant_id));
    } catch (error) {
      // No enviamos el error al state, solo mostramos el snack
      dispatch({ type: UPDATE_TENANT_USER_SUCCESS }); // Marcamos como éxito para no alterar la UI
      const snack = {
        open: true,
        message: 'Error al actualizar usuario: ' + (error.message || String(error)),
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
      // Aseguramos que la lista de usuarios se mantenga actualizada
      dispatch(getTenantUsers(userData.tenant_id));
    }
  };
}

export function deleteTenantUser(user_id, tenant_id) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: DELETE_TENANT_USER_REQUEST });
    try {
      await dataSource.deleteTenantUser(user_id, tenant_id);
      dispatch({ type: DELETE_TENANT_USER_SUCCESS });
      const snack = {
        open: true,
        message: 'Usuario eliminado exitosamente',
        severity: 'success',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
      // Recargar la lista de usuarios
      dispatch(getTenantUsers(tenant_id));
    } catch (error) {
      // No enviamos el error al state, solo mostramos el snack
      dispatch({ type: DELETE_TENANT_USER_SUCCESS }); // Marcamos como éxito para no alterar la UI
      const snack = {
        open: true,
        message: 'Error al eliminar usuario: ' + (error.message || String(error)),
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
      // Aseguramos que la lista de usuarios se mantenga actualizada
      dispatch(getTenantUsers(tenant_id));
    }
  };
} 